import RateTariffComponent from "../common/RateTariffComponent";

const RateCalculator = () => {
  return (
    <div>
      <div className="bg-[#efefef] flex flex-col justify-center items-center h-[130px] mb-6 sm:mb-8 md:mb-8 lg:mb-7 px-4">
        <h1 className="text-2xl sm:text-3xl md:text-3xl lg:text-4xl font-bold text-center">
          Rate Calculator
        </h1>
      </div>

      <RateTariffComponent />
    </div>
  );
};

export default RateCalculator;
